import api from "../proxy/config";
import axios from "./axiosConfig";

const getHeaders = () => ({
  Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
});

const handleBackendError = (error, defaultMsg) => {
  if (
    error.response?.status === 500
    || (typeof error.response?.data === "string" && error.response.data.includes("Internal Server Error"))
  ) {
    throw new Error("Si è verificato un problema, riprova più tardi.");
  }
  const backendError = error.response?.data;
  const message = typeof backendError === "string"
    ? backendError
    : (backendError?.message || backendError?.error || defaultMsg);
  throw new Error(message);
};

export const getReindexStatus = async () => {
  const response = await axios.post(api.reindexStatus, {}, {
    headers: getHeaders(),
  });
  return response.data;
};

export const triggerFullReindex = async () => {
  try {
    const response = await axios.post(api.reindexFull, {}, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 409) {
      const current = await getReindexStatus().catch(() => null);
      if (current?.full?.running) {
        return { started: false, alreadyRunning: true, scope: "FULL" };
      }
    }
    handleBackendError(error, "Errore durante l'avvio del reindex completo");
  }
  return null;
};

export const triggerVendorReindex = async (vendorId) => {
  try {
    const response = await axios.post(api.reindexVendor(vendorId), {}, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    handleBackendError(error, "Errore durante l'avvio del reindex vendor");
  }
  return null;
};

// Backward-compatible helpers used by legacy callers.
export const getIndexStatus = async () => {
  const data = await getReindexStatus();
  return data?.full || {
    running: false,
    phase: "IDLE",
    processed: 0,
    total: 0,
    percentage: 0,
  };
};

export const getVendorIndexStatus = async () => {
  const data = await getReindexStatus();
  return { vendors: data?.vendors || [] };
};

export const postRefreshIndex = triggerFullReindex;
